import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    IAddClientFormPayload,
    IClientFormFilters,
    IUpdateClientFormPayload,
} from "../types/client-forms.types";

export async function getClientForms(filters: IClientFormFilters) {
    const response = await axios.get("/client-forms", {
        params: handleRemoveEmptyParamFromQueryParams(filters),
    });
    return response.data;
}

export async function updateClientForm(
    clientId: string,
    formId: string,
    data: IUpdateClientFormPayload
) {
    const response = await axios.patch(
        `/client/${clientId}/form/${formId}`,
        data
    );
    return response.data;
}

export async function createClientForm(
    clientId: string,
    data: IAddClientFormPayload
) {
    const response = await axios.post(`/client/${clientId}/form`, data);
    return response.data;
}

export async function uploadFormDocument(
    clientId: string,
    formId: string,
    formData: FormData
) {
    const response = await axios.post(
        `/client/${clientId}/form/${formId}/document`,
        formData,
        {
            headers: { "Content-Type": "multipart/form-data" },
        }
    );
    return response.data;
}

export async function deleteClientForm(clientId: string, formId: string) {
    const response = await axios.delete(`/client/${clientId}/form/${formId}`);
    return response.data;
}

export async function deleteFormDocument(
    clientId: string,
    formId: string,
    documentId: string
) {
    const response = await axios.delete(
        `/client/${clientId}/form/${formId}/document/${documentId}`
    );
    return response.data;
}
